<template>
  <public-page
    page="fission"
    title=""
    ref="publicPage"
    @login="login"
    :directBack="false"
    @back="back"
    :doTrack="type === 'page'"
    :hasHeaderBorder="false"
    :showHeader="false"
    :bgColor="getBgColor"
    class="fission-home"
  >
    <template #page>
      <section :class="['activity-fission-wrapper', fissionStyleGame, type]">
        <!-- 头部banner区域 -->
        <section :class="['header-wrapper', type]">
          <header-banner
            @to-rules="toRules"
            :type="type"
            :number="everyOneMaxAwardNum"
            :headerBanner="headerBanner"
          />
        </section>
        <!-- 积分区域 -->
        <section class="score-wrapper" v-if="loginStatus">
          <dash-bord
            :type="type"
            @to-exchange="toExchange"
            :swipeList="swipeList"
            :showAward="showAward"
            :number="userPoints.activityAward"
            :activityId="activityConfigDatas.activityId"
          />
        </section>
        <!-- 卡片区域 -->
        <section
          class="giftCard-wrapper padding"
          :class="[loginStatus ? 'has-signed-in' : 'not-signed-in', type]"
        >
          <gift-card
            :dataSource="awardList"
            :type="type"
            @click-share="clickShare"
            :userPoints="userPoints"
            :activityId="activityConfigDatas.activityId"
            :showShareBtn="showShareBtn && loginStatus"
            :hasBgColor="type === 'page'"
            :showLoginBtn="type === 'page' && !loginStatus"
            @login="goToLogin"
            :displayMode="displayMode"
            :firstShareStatus="firstShareFinished"
            :showScore="showAward"
          />
          <LoginBtn
            class="page-login-btns"
            v-if="type === 'page' && !loginStatus"
            @click="goToLogin"
          />
        </section>
        <!-- 进度条区域 -->
        <section class="progressBar-wrapper padding" v-if="loginStatus">
          <progress-bar
            :configs="activityConfigDatas"
            :progressDatas="progressConfigs"
            :awardList="awardList"
            :type="type"
          />
        </section>
        <!-- 用户列表区域 -->
        <section
          :class="['userList-wrapper', fissionStyleGame]"
          v-if="loginStatus"
        >
          <img
            alt="divider"
            class="divider"
            :src="require('@/assets/images/activities/fission/user-bg.png')"
          />
          <user-list
            :dataSource="progressConfigs.detailList || []"
            :configs="activityConfigDatas"
            :progressDatas="progressConfigs"
            :awardList="awardList"
            :type="type"
          />
        </section>
      </section>
      <!-- 分享面板 -->
      <template v-if="type === 'page'">
        <share-popup
          ref="sharePopup"
          page="fission"
          :activitySource="source"
          class="share-btn-wrapper"
        />
      </template>
      <!-- 登录面板 -->
      <CommonLogin v-if="!loginStatus" ref="commonLogin" page="fission" />
    </template>
  </public-page>
</template>

<script>
  import PublicPage from '@/components/PublicPage'
  import HeaderBanner from '../components/HeaderBanner'
  import DashBord from '../components/DashBord'
  import GiftCard from '../components/GiftCard'
  import ProgressBar from '../components/ProgressBar'
  import UserList from '../components/UserList'
  import SharePopup from '../components/SharePopup'
  import {
    getActivityList,
    getUserPoints,
    getUserProgress,
    getCouponList,
  } from '@/api/fission'
  import { mapState, mapMutations } from 'vuex'
  import { stringToJson } from '@/utils/tool'
  import {
    share_show,
    share_click,
    fission_tip,
    login_quick,
  } from '../firebase'
  import CommonLogin from '@/components/LoginBtn'
  import { LoginBtn } from '../components/CommonBtns/index.js'
  import { queryOrderStatus } from '@/api/order'
  import { normalizeFissionStyleGame, styleInfo } from '../configData.js'
  import { storage, backPageShowFissionPopup } from '@/utils/storage'
  import { setRouteBase } from '@/config/routePrefix'
  import { region } from '@/utils/utils.js'

  const GAMES_RISK = ['pubgm', 'genshin', 'undawn']

  export default {
    name: 'fission-home',
    props: {
      type: {
        default: 'page',
        type: String,
      },
      popupOpenType: {
        default: '',
        type: String,
      },
      showShareBtn: {
        type: Boolean,
        default: true,
      },
      displayMode: {
        default: '',
        type: String,
      },
      game: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        showAward: false,
        userPoints: {}, // 积分相关信息
        activityConfigDatas: {}, // 活动配置信息
        progressConfigs: {}, //进度条信息
        source: '',
        everyOneMaxAwardNum: 0,
        shareConfigInfos: {},
        firstShareFinished: false, // 是否完成首次分享
        userToLogin: false,
        couponList: [], // 奖品类型为优惠券的列表
        awardList: [], // 筛选与处理后的奖品列表
      }
    },
    components: {
      PublicPage,
      HeaderBanner,
      DashBord,
      GiftCard,
      ProgressBar,
      UserList,
      SharePopup,
      CommonLogin,
      LoginBtn,
    },
    computed: {
      ...mapState(['region', 'userInfo', 'shareInfos', 'fissionGame']),
      awardCardDatas() {
        const { activityConfigDatas } = this
        return activityConfigDatas?.extraInfo?.splitActivityConditionList || []
      },
      loginStatus() {
        const { kicoinId, kicoinToken } = this.userInfo || {}
        if (kicoinId && kicoinToken) {
          return true
        }
        return false
      },
      swipeList() {
        const { activityConfigDatas } = this
        const list =
          activityConfigDatas?.extraInfo?.carouselData?.split('\n') || []
        return list
      },
      headerBanner() {
        const { activityConfigDatas } = this
        const picUrl = {
          page: activityConfigDatas?.extraInfo?.topPic || '',
          popup: activityConfigDatas?.extraInfo?.popPic || '',
        }
        return picUrl[this.type]
      },
      fissionStyleGame() {
        return normalizeFissionStyleGame(this.fissionGame)
      },
      getBgColor() {
        const gameConfig = styleInfo[this.fissionStyleGame] || {}
        return gameConfig.color?.fissionBg || 'rgba(21, 26, 45, 1)'
      },
      suffix() {
        return `_${this.region}_${this.fissionGame}`
      },
    },
    watch: {
      userInfo: {
        handler(data) {
          if (
            data &&
            data.kicoinId &&
            data.kicoinToken &&
            this.type === 'page'
          ) {
            const { activityId } = this.activityConfigDatas || {}
            if (this.userToLogin) {
              this.getActivityInfos()
            }
            this.getProgress(activityId, this.fissionGame)
            this.getPoints(activityId, this.fissionGame)
          }
        },
        deep: true,
        immediate: true,
      },
      shareInfos(data = {}) {
        if (data && data.id) {
          share_click({
            page: 'fission',
            share_name: data.id,
          })
        }
      },
    },
    middleware({ redirect, route, query }) {
      // 无活动信息则跳回到首页
      if (route.path.indexOf('/fission') === -1) {
        return redirect({
          path: '/',
          query,
        })
      }
    },
    async asyncData({ store, redirect, query, req }) {
      /* eslint-disable no-console*/
      console.log(
        'fission-asyncData',
        req?.headers['x-forwarded-host'],
        req?.headers.host,
        req?.url
      )
      // 只有页面组件（即活动落地页）才会走该方法
      const { state } = store
      let activityInfo = {}
      const ssrLocationParams = {
        host: req?.headers.host,
        url: req?.url,
        health_checks: req?.headers?.['is-health-examination'] || '',
      }
      try {
        const { source = 'ns', activitySource = '', activityId = '' } = query
        const payload = {
          activityType: 4,
          activitySource: activitySource || source,
          country: region(ssrLocationParams, true),
        }
        if (activityId && typeof activityId === 'string') {
          payload.activityIdString = activityId.split('?')[0]
        } else {
          payload.game = state.gameName
        }
        console.log('------ getActivityList payload: ', payload)
        const res = await getActivityList(payload, ssrLocationParams)
        console.log('裂变结果 res===>>>', typeof res, res)
        if (res && res.length) {
          const activity = res[0] || {}
          if (activity && activity.extraInfo) {
            activity.extraInfo = stringToJson(activity.extraInfo)
          }
          store.commit('setFissionInfos', activity)
          store.commit('setFissionGameName', activity.game)
          activityInfo = activity

          // ! 由于三方薅羊毛进行机器人刷数据，前端针对落地页进行跳转，同时产品@胡冬需要保证不进入当前的落地页
          if (GAMES_RISK.includes(activity.game)) {
            const fix = setRouteBase(ssrLocationParams)
            return redirect({
              path: fix,
            })
          }
        } else {
          const fix = setRouteBase(ssrLocationParams)
          return redirect({
            path: fix,
          })
        }
      } catch (error) {
        console.log('error in asyncData ====>', error)
        const fix = setRouteBase(ssrLocationParams)
        return redirect({
          path: fix,
        })
      }
      return {
        activityConfigDatas: activityInfo,
      }
    },
    mounted() {
      this.getQueryOrderStatus()
      const { source = 'ns', activitySource } = this.$route.query || {}
      this.source = activitySource || source
      // 以下只有在客户端的大弹窗内执行
      if (process.client && this.type === 'popup') {
        this.getActivityInfos().then((data) => {
          // console.log('大弹窗 ------ getActivityInfos： ', data)
          this.activityConfigDatas = data
          this.setFissionInfos(data)
          this.setFissionGameName(data.game)
          this.getEveryOneMaxAwardNum(this.activityConfigDatas)
          this.awardList = this.awardCardDatas
          const couponIdString = this.getCouponIdString(
            data.extraInfo.splitActivityConditionList
          )
          // console.log('------ couponIdString： ', couponIdString)
          this.getCouponInfos(couponIdString)

          const { activityId } = this.activityConfigDatas || {}
          if (this.loginStatus) {
            this.getProgress(activityId, this.fissionGame)
            this.getPoints(activityId, this.fissionGame)
          }
        })
      } else if (this.type === 'page') {
        // 走的 asyncData
        this.getEveryOneMaxAwardNum(this.activityConfigDatas)
        this.awardList = this.awardCardDatas
        const couponIdString = this.getCouponIdString(
          this.activityConfigDatas?.extraInfo?.splitActivityConditionList
        )
        this.getCouponInfos(couponIdString)
        const { activityId } = this.activityConfigDatas || {}
        if (this.loginStatus) {
          // TODO: 这里的判断似乎不准，刷新页面就丢失了状态
          this.getProgress(activityId, this.fissionGame)
          this.getPoints(activityId, this.fissionGame)
        }
      }
    },
    methods: {
      ...mapMutations([
        'setFissionInfos',
        'setFissionGameName',
        'setFissionFirstStatus',
      ]),
      getQueryOrderStatus() {
        const { orderNo } = this.$route.query
        if (!orderNo) return

        queryOrderStatus(orderNo, this.region)
      },
      // 登录成功回调
      login(data) {
        const { status } = data || {}
        // 登录成功
        if (status * 1 === 1) {
          // this.initPage()
        }
      },
      back() {},
      initPage() {
        this.$nextTick(() => {
          this.getActivityInfos()
        })
      },
      // 获取活动配置信息
      async getActivityInfos() {
        try {
          const res = await getActivityList({
            game: this.game,
            country: this.region,
            activityType: 4,
            activitySource: this.source || '',
          })
          if (res && res.length) {
            const activity = res[0] || {}
            if (activity && activity.extraInfo) {
              activity.extraInfo = stringToJson(activity.extraInfo)
            }
            return Promise.resolve(activity)
          } else {
            return Promise.resolve({})
          }
        } catch (e) {
          return Promise.reject(e)
        }
      },
      // 活动进度
      getProgress(activityId, game) {
        getUserProgress({
          game,
          country: this.region,
          activityId,
          source: this.source,
        }).then((res) => {
          if (res && res.detailList) {
            this.progressConfigs = res || {}
          }
        })
      },
      // 用户积分
      getPoints(activityId, game) {
        if (!activityId) {
          return
        }
        getUserPoints({
          game,
          country: this.region,
          activityId,
          source: this.source,
        })
          .then((res) => {
            this.userPoints = res || {}
            const { shareStatus } = res || {}
            this.firstShareFinished = shareStatus * 1 === 2 // 1: 未首次分享，2：已首次分享
            this.setFissionFirstStatus(shareStatus * 1 === 2)
            this.$emit('first-share-status', shareStatus * 1 === 2)
          })
          .catch((e) => {
            // 未返回 data 则不展示奖品
            window.console.log('------ getUserPoints', e)
          })
      },
      clickShare() {
        this.$emit('click-share')
        share_show({
          from: this.popupOpenType,
        })
        if (this.type === 'page') {
          this.$refs.sharePopup && this.$refs.sharePopup.switch()
        }
      },

      toRules() {
        fission_tip({
          from: this.popupOpenType,
          page: 'fission',
        })
        // 在弹框页面中跳转规则页返回来是还要自动展示弹框页
        if (this.type !== 'page') {
          storage.set(backPageShowFissionPopup + this.suffix, 1)
        }
      },
      toExchange() {
        // 在弹框页面中跳转规则页返回来是还要自动展示弹框页
        if (this.type !== 'page') {
          storage.set(backPageShowFissionPopup + this.suffix, 1)
        }
      },
      getEveryOneMaxAwardNum(activity) {
        const { extraInfo } = activity || {}
        const { splitActivityConditionList = [] } = extraInfo || {}
        // 判断是否展示 钻石/uc 区域
        this.showAward = splitActivityConditionList.some((item) => {
          return item.awardType * 1 === 4
        })
        // 初始奖励
        const initConfigInfos = this.getConfigInfos(
          splitActivityConditionList,
          1
        )
        // 分享
        const shareConfigInfos = this.getConfigInfos(
          splitActivityConditionList,
          2
        )
        // this.shareConfigInfos = shareConfigInfos
        // 注册
        const loginConfigInfos = this.getConfigInfos(
          splitActivityConditionList,
          3
        )
        // 付费
        const paymentConfigInfos = this.getConfigInfos(
          splitActivityConditionList,
          4
        )
        const paymentedConfigInfos = this.getConfigInfos(
          splitActivityConditionList,
          5
        )
        const { awardCount: initAwards = 0 } = initConfigInfos
        const { awardCount: shareAwards = 0 } = shareConfigInfos
        const { awardCount: loginAwards = 0 } = loginConfigInfos
        const { awardCount: paymentCount = 0 } = paymentConfigInfos
        const { conditionCount = 0, awardCount: paymentAwards = 0 } =
          paymentedConfigInfos

        this.everyOneMaxAwardNum =
          initAwards +
          shareAwards +
          loginAwards +
          paymentCount * conditionCount +
          paymentAwards
      },
      goToLogin(type) {
        const { activityId = '' } = this.activityConfigDatas || {}
        login_quick({
          login_way: type,
          button: activityId || 'fission',
          from: this.popupOpenType,
        })
        this.userToLogin = true
        if (type === 'vk') {
          this.$refs.commonLogin &&
            this.$refs.commonLogin.loginVK({
              button: activityId || 'fission',
            })
        } else {
          this.$refs.commonLogin &&
            this.$refs.commonLogin.login(type, null, {
              button: activityId || 'fission',
            })
        }
      },
      getConfigInfos(datas = [], type) {
        // 根据商品奖励类型返回
        return (
          (datas.filter((item) => item.conditionType * 1 === type) || [])[0] ||
          {}
        )
      },
      getCouponIdString(list = []) {
        // 筛选优惠券奖品信息
        this.couponList = list
          .map((curr, index) => {
            if (
              [3, 4, 5].indexOf(curr.conditionType * 1) > -1 &&
              curr.awardType * 1 === 3
            ) {
              return {
                index,
                couponId: curr.couponId,
              }
            }
          })
          .filter((item) => item !== undefined)
        // 返回用逗号分隔的 couponId 字符串
        return this.couponList.map((item) => item.couponId).join(',')
      },
      async getCouponInfos(couponIdString) {
        const res = await getCouponList({
          country: this.region,
          couponIdString,
        })
        // 合并优惠券数据到 awardCardDatas 中
        if (res && res.length > 0) {
          res.forEach((item, index) => {
            const order = this.couponList[index].index // 对应接口返回数据中的原始索引
            this.awardList.splice(order, 1, {
              ...this.awardCardDatas[order],
              ...item,
            })
          })
        }
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
